
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JobWorkReceiptTaxGrid extends Serenity.EntityGrid<JobWorkReceiptTaxRow, any> {
        protected getColumnsKey() { return 'Production.JobWorkReceiptTax'; }
        protected getIdProperty() { return JobWorkReceiptTaxRow.idProperty; }
        protected getInsertPermission() { return JobWorkReceiptTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkReceiptTaxRow.localTextPrefix; }
        protected getService() { return JobWorkReceiptTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}